export const getAssets = {
    query: 'get-assets'
};

export const getAssetsList = {
    query: 'get-assets-list'
};

export const getAssetById = {
    query: 'get-asset-by-id',
    assetId: 'assetId'
};

export const getAssetBasicDetailById = {
    query: 'get-asset-basic-detail-by-id',
    assetId: 'assetId'
};

export const getAssetTagsDetailById = {
    query: 'get-asset-tags-detail-by-id',
    assetId: 'assetId'
};

export const getComponents = {
    query: 'get-components'
};

export const getComponentsView = {
    query: 'get-components-view'
};

export const getComponentById = {
    query: 'get-component-by-id',
    id: 'id'
};

export const getModelsList = {
    query: 'get-models-list'
};

export const getModelById = {
    query: 'get-model-by-id',
    id: 'id'
};

export const getModelByIdForDashboards = {
    query: 'get-model-by-id-for-dashboard',
    id: 'id'
};

export const getEUs = {
    query: 'get-eus'
};

export const getHistorizedData = {
    query: 'get-historized-data'
};

export const getPropertyTypes = {
    query: 'get-property-types'
};

export const getComponentsWithImages = {
    query: 'get-components-with-images'
};

export const getDatasourceNodesByAssetId = {
    query: 'get-datasource-nodes-by-asset-id',
    assetId: 'assetId'
};

// Get Data sources info, Get Data sources  nodes info // datasourcesData
export const getDatasources = {
    query: 'get-datasources'
};

export const getDatasourceById = {
    query: 'get-datasource-by-id',
    id: 'id'
};

// real name  getLinkedTags
export const getLinkedTagsByAssetId = {
    query: 'get-linked-tags-by-asset-id',
    assetId: 'assetId'
};

// real name  getLinkedTags
export const getLinkedTagsByNodeId = {
    query: 'get-linked-tags-by-node-id',
    nodeId: 'nodeId'
};

export const getDatasourceTypes = {
    query: 'get-datasource-types'
};

export const getMeasurments = {
    query: 'get-measurements'
};

export const getUomsByMeasurmentById = {
    query: 'get-uoms-by-measurement-id',
    id: 'id'
};

export const getUoms = {
    query: 'get-uoms'
};

export const getUomGroups = {
    query: 'get-uom-groups'
};

export const getAlarmSeverities = {
    query: 'get-alarm-severities'
};

export const getConditionTypes = {
    query: 'get-condition-types'
};

export const getSubscriptionViewByAssetId = {
    query: 'get-subscription-view-by-asset-id',
    assetId: 'assetId'
};

export const getEventTypes = {
    query: 'get-event-types'
};

export const getPerspectives = {
    query: 'get-perspectives'
};

export const getPerspectivesById = {
    query: 'get-perspective-by-id',
    id: 'id'
};

export const getAlarmEvents = {
    query: 'get-alarm-events'
};

// for map panel alarms toggle functionality
export const getAlarmsByAssetIds = {
    query: 'get-alarms-by-asset-ids',
    assetIds: 'assetIds'
};

export const getAlarmDisplaySettings = {
    query: 'get-alarm-display-settings'
};

export const getAggregateFunctions = {
    query: 'get-aggregate-functions'
};


export const getChartTypes = { // will be deleted, also from graphqlApi.service.ts
    query: 'get-chart-types'
};

export const getComponentSubChartTypes = { // will be deleted, also from graphqlApi.service.ts
    query: 'get-component-sub-chart-types',
    chartTypeId: 'chartTypeId'
};

export const getModelSubChartTypes = { // will be deleted, also from graphqlApi.service.ts
    query: 'get-model-sub-chart-types',
    chartTypeId: 'chartTypeId'
};

export const getGroupSubChartTypes = { // will be deleted, also from graphqlApi.service.ts
    query: 'get-group-sub-chart-types',
    chartTypeId: 'chartTypeId'
};

export const getComponentPanelsByIds = {
    query: 'get-component-panels-by-ids',
    componentIds: 'componentIds'
};

export const getGroupPanelsById = {
    query: 'get-group-panels-by-id',
    perspectiveGroupId: 'perspectiveGroupId'
};

export const getDashboardsById = {
    query: 'get-dashboards-by-id',
    modelId: 'modelId'
};

export const getGroupDashboardsById = {
    query: 'get-group-dashboards-by-id',
    perspectiveGroupId: "perspectiveGroupId"
};

export const getDashboardPanelsByPanelIds = {
    query: 'get-dashboard-panels-by-panel-ids',
    panelIds: 'panelIds'
};

export const getModelIdByAssetId = {
    query: 'get-model-id-by-asset-id',
    assetId: 'assetId'
};

export const getComponentTypesNVendors = {
    query: 'get-component-types-and-vendors',
};

export const getComponentTypes = {
    query: 'get-component-types'
};

export const getVendorTypes = {
    query: 'get-vendor-types'
};

export const getModelTypes = {
    query: 'get-model-types'
};

export const getDSGroups = {
    query: 'get-ds-groups',
};

export const getQualityCodes = {
    query: 'get-quality-codes'
};

export const getQualityCodesTagUnlink = {
    query: 'get-quality-codes-tag-unlink'
};

export const getQualityCodesNodeUnlink = {
    query: 'get-quality-codes-dsnode-unlink'
};

export const getDefaultPerspectiveUser = {
    query: 'get-default-perspective-for-user',
    userName: 'userName'
};

export const getPerspectivesDetailsByIds = {
    query: 'get-perspective-details-by-ids',
    perspectiveIds: 'perspectiveIds'
};

export const getRefPanelTypes = {
    query: 'get-ref-panel-types'
};

export const getDistinctGroupTags = {
    query: 'get-distinct-perspectivegroup-tags',
    perspectiveGroupId: 'perspectiveGroupId'
};

// get group assets tags by group id and model ids
export const getGroupTagsByGroupNModelIds = {
    query: 'get-group-tags-by-model-ids',
    perspectiveGroupId: 'perspectiveGroupId',
    modelIds: 'modelIds'
};

export const getGroupTagsInstances = { //(1)
    query: 'get-perspectivegroup-tag-instances',
    perspectiveGroupId: 'perspectiveGroupId',
    tagName: 'tagName'
};

export const getGroupPropertiesInstances = { // (11)
    query: 'get-asset-property-details-for-perspectivegroup',
    perspectiveGroupId: 'perspectiveGroupId',
    propertyName: 'propertyName'
};

// get model coordinates properties that are overriden at asset level (for map panel) against a perspectiveGroupId
export const getGroupCoordinateProperties = {
    query: 'get-group-coordinate-properties',
    perspectiveGroupId: 'perspectiveGroupId',
};

export const getGroupTagColNames = {
    query: 'get-perspectivegroup-tag-col-names',
    perspectiveGroupId: 'perspectiveGroupId',
    tagIds: 'tagIds',
    modelIds: 'modelIds',
    ciIds: 'ciIds',
    cTagIds: 'cTagIds',
    cModelIds: 'cModelIds',
};

export const getGroupsAssetsDetail = {
    query: 'get-perspectivegroups-assets-detail',
    assetIds: 'assetIds'
};

export const getDistinctProperties = {
    query: 'get-distinct-properties-for-perspectivegroup',
    perspectiveGroupId: 'perspectiveGroupId'
};

// get group assets Properties by group id and model ids
export const getGroupPropertiesByGroupNModelIds = {
    query: 'get-group-properties-by-model-ids',
    perspectiveGroupId: 'perspectiveGroupId',
    modelIds: 'modelIds'
};

export const getGroupPropertyColNames = {
    query: 'get-perspectivegroup-property-col-names',
    perspectiveGroupId: 'perspectiveGroupId',
    propertyIds: 'propertyIds',
    modelIds: 'modelIds',
    ciIds: 'ciIds',
    mPropertyIds: 'mPropertyIds',
    mModelIds: 'mModelIds'
};

export const getCountConditionTypes = {
    query: 'get-count-condition-types'
};

export const getUsers = {
    query: 'get-users'
};

export const getUserById = {
    query: 'get-user-by-id',
    userId: 'userId'
};

export const getRoles = {
    query: 'get-roles'
};

export const getRoleByName = {
    query: 'get-role-by-name',
    roleName: 'roleName'
};

export const getUserGroups = {
    query: 'get-user-groups'
};

export const getUserGroupById = {
    query: 'get-user-group-by-id',
    groupId: 'groupId'
};

export const getFeatures = {
    query: 'get-features'
};

export const getFeatureByName = {
    query: 'get-feature-by-name',
    featureName: 'featureName'
};

export const getTags = {
    query: 'get-tags-by-entity-id',
    entityId: 'entityId'
};

export const getTagsByName = {
    query: 'get-tags-by-entity-name',
    entityName: 'entityName'
};

export const getTagTypes = {
    query: 'get-tag-types',
};

export const getGroups = {
    query: 'get-groups',
};

export const getNodesByName = {
    query: 'get-nodes-by-name',
    nodeName: 'nodeName',
};

export const getRegistrationMetrics = {
    query: 'get-registered-metrics',
};

export const getUserGroupsWithMembers = {
    query: 'get-usergroup-with-members',
};

// get assets and acls by user group id
export const getAssetsNAclsByUserGroupId = {
    query: 'get-assets-and-acls-by-user-group-id',
    userGroupId: 'userGroupId'
};

// get user groups and acls by asset id
export const getUserGroupsNAclsByAssetId = {
    query: 'get-user-groups-and-acls-by-asset-id',
    assetId: 'assetId'
};

// get features by roles
export const getFeaturesByRoles = {
    query: 'get-features-by-role',
    roles: 'roles'
};

// get features detail by features
export const getFeaturesDetailByFeatures = {
    query: 'get-features-by-name',
    features: 'features'
};

// get base properties and override properties by PropertyIds
export const getPropertiesByIds = {
    query: 'get-properties-by-id',
    propertyIds: 'propertyIds'
};

export const getFeaturesTreeView = {
    query: 'get-features_tree_view'
}

// get time aggr ranges
export const getTimeAggrRanges = {
    query: 'get-time-agg-ranges'
}

// get component-> aggrs
export const getTimeAggrsByCompId = {
    query: 'get-time-agg-by-comp-id',
    componentId: 'componentId'
}

// get model-> aggrs
export const getTimeAggrsByModelId = {
    query: 'get-time-agg-by-model-id',
    modelId: 'modelId'
}

// get distinct tags names
export const getTagsNames = {
    query: 'get-tags-names'
}

// get distinct props names
export const getPropsNames = {
    query: 'get-props-names'
}

// get Registered Node Detail for node registration page
export const getRegisteredNodeDetail = {
    query: 'get-registered-node-detail'
}

// get-all-chart-types-for-component
export const getChartsTypesForComponent = {
    query: 'get-all-chart-types-for-component'
}

// get-all-chart-types-for-model
export const getChartsTypesForModel = {
    query: 'get-all-chart-types-for-model'
}

// get-all-chart-types-for-group
export const getChartsTypesForGroup = {
    query: 'get-all-chart-types-for-group'
}